const normalize = value => (value || '').toLowerCase().replace(/[^a-z0-9äöüß]/g, '')

const levenshtein = (a, b) => {
  const previous = Array.from({ length: b.length + 1 }, (_, index) => index)
  for (let i = 1; i <= a.length; i++) {
    let diagonal = previous[0]
    previous[0] = i
    for (let j = 1; j <= b.length; j++) {
      const above = previous[j]
      previous[j] = Math.min(previous[j] + 1, previous[j - 1] + 1, diagonal + (a[i - 1] === b[j - 1] ? 0 : 1))
      diagonal = above
    }
  }
  return previous[b.length]
}

export const findExactTag = (name, tags) => {
  const wanted = (name || '').trim().toLowerCase()
  if (!wanted) return null
  return tags.find(tag => tag.name.trim().toLowerCase() === wanted) || null
}

export const findSimilarTags = (name, tags, limit = 3) => {
  const wanted = normalize(name)
  if (wanted.length < 2) return []
  return tags
    .filter(tag => {
      const candidate = normalize(tag.name)
      if (!candidate) return false
      if (candidate === wanted || candidate.includes(wanted) || wanted.includes(candidate)) return true
      const tolerance = Math.max(candidate.length, wanted.length) >= 6 ? 2 : 1
      return levenshtein(candidate, wanted) <= tolerance
    })
    .slice(0, limit)
}
